<template>
  <el-cascader :ref="refs" placeholder="请选择专业课程" :popper-class="refs" @visible-change="visibleChange" @expand-change="visibleChange" :disabled="disabled" :options="datas" :props="props" filterable v-model="ids" @change="checkChange"
    :show-all-levels="showAllLevels" :clearable="clearable">
    <div slot-scope="{data}" class="custom-tree-node" :class="{ 'is-active': ids == data.id }">
      <span>{{ data.name }}</span>
    </div>
  </el-cascader>
</template>
<script>

export default {
  props: {
    value: "",
    showAllLevels: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => { return {} },
    },
    root: 0,
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultDisabled: {
      type: Array,
      default: () => { return [] },
    },
    skillType: {
      type: Number,
      default: 1,
    },
    type: {
      type: Number,
      default: 40,
    },
    defaultLevel: {
      type: Number,
      default: 0,
    },
    target: "",//目标以展示默认值
    isAll: {
      type: Boolean,
      default: () => { return false },
    },
  },
  data() {
    return {
      datas: [],
      checkedKeys: [],
      ids: "",
      props: {
        checkStrictly: true,
        label: "name",
        value: "id",
      },
      isFirst: true,
      typeDatas: [],
    }
  },
  watch: {
    value: function (newValue) {
      this.ids = newValue;
      if (this.ids && this.isFirst) {
        this.checkChange(this.ids)
        this.isFirst = false;
      }
    },
    defaultDisabled() {
      this.setChildren(this.datas);
    },
    ids(val) {
      if (!this.props.multiple && Array.isArray(val)) {
        this.$emit('input', val[val.length - 1]);
      } else {
        this.$emit('input', val);
      }
    },
  },
  beforeDestroy() {
    this.$bus.$off('professional_update')
  },
  created() {
    this.props = Object.assign(this.props, this.config);
    this.refs = "professional_" + new Date().getTime();
    this.knowledgeSkillType = this.skillType || Number(this.$route.query.knowledgeSkillType || 0);
  },
  mounted() {
    this.ids = this.value;
    this.$bus.$on("professional_update", data => {
      this.getData();
    })
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        pId: 0,
        isHide: false,
        type: 20,
        tenantCode: this.$root.tenantInfo.code,
      }
      this.loading = true;
      let url = "/api/SubjectCatalogue/GetSubjectCatalogueTreeByTenantCode";
      if (this.isAll) {
        params = {
          pId: 0,
          isHide: false,
        }
        url = "/api/SubjectCatalogue/GetSubjectCatalogueTree";
      }
      this.https("get", url, params).then(res => {
        this.loading = false;
        if (res.success) {
          let data = {};
          res.response.name = "根目录";
          if (this.root == 0) {
            data = [res.response];
          } else if (this.root == 1) {
            data = res.response.children;
          }
          this.setChildren(data);
          this.datas = data;
          if (this.ids && this.isFirst) {
            this.checkChange(this.ids)
            this.isFirst = false;
          }
          this.$emit("getTypeData", this.typeDatas);
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    setChildren(arr) {
      arr.map(item => {
        //筛选技能还是章节--START
        if (item.children && item.children.length > 0) {
          if (this.skillType && item.children[0].type == 50 && this.skillType > 0) {
            item.children = item.children.filter(s => s.knowledgeSkillType == this.skillType);
          }
        }
        //筛选技能还是章节--END
        item.childrens = item.children || [];
        if (this.defaultDisabled.indexOf(item.id) >= 0) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.type < this.type && !this.props.checkStrictly) {
          item.children = item.children || [];
        }
        if (this.defaultLevel == 1 && item.type == this.type && (!this.ids || this.ids.length == 0) && !this.target) {
          this.ids = item.id;
          this.$emit('change', item);
        }
        if (item.children && item.children.length > 0) {
          if (this.defaultLevel == 2 && item.type == this.type && (!this.ids || this.ids.length == 0) && !this.target) {
            this.ids = item.id;
            this.$emit('change', item);
          }
          if (this.target) {
            let targetObj = item.children.find(item => item.id == this.target);
            if (targetObj) {
              this.ids = item.id;
              this.$emit('change', item, targetObj);
            }
          }
          let childType = item.children[0].type;
          if (childType > this.type) {
            item.children = null;
          }
        }
        if (item.type == this.type) {
          this.typeDatas.push(item);
        }
        if (item.children && item.children.length > 0) {
          this.setChildren(item.children);
        }
      })
    },
    checkChange(val) {
      if (this.props.multiple) {
        this.$emit('input', val);
      } else {
        this.$emit('input', Array.isArray(val) ? val[val.length - 1] : val);
      }
      setTimeout(() => {
        let checkedNodes = this.$refs[this.refs].getCheckedNodes();
        let datas = [];
        checkedNodes.map(item => {
          if (item) {
            datas.push(item.data);
          }
        })
        if (this.props.multiple) {
          this.$emit("change", datas);
        } else {
          let node = checkedNodes[0];
          if (node) {
            if (this.target) {
              let targetObj = node.data.childrens.find(item => item.id == this.target);
              this.$emit('change', node.data, targetObj);
            } else {
              this.$emit('change', node.data);
            }
          }
        }
      });
    },
    visibleChange(val) {
      if (this.props.checkStrictly && val) {
        setTimeout(() => {
          var depts = document.getElementsByClassName(this.refs)[0];
          var btns = depts.getElementsByClassName('el-radio__inner');
          for (let i = 0; i < btns.length; i++) {
            btns[i].onclick = () => {
              this.$refs[this.refs]._data.dropDownVisible = false;
            }
          }
        }, 200);
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;

  &.is-active {
    color: #04adc0;
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProfessionalTree.vue